import {
  ChangeDetectionStrategy,
  Component,
  input,
  HostBinding,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../presentation/icon/icon.component';
import { UiIconControlDirective } from '../../../directives/ui/ui-icon-control.directive';
import { CopyDirective } from '../../../directives/copy.directive';

@Component({
  selector: 'btn',
  imports: [CommonModule, IconComponent, CopyDirective],
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent extends UiIconControlDirective {
  //#region Host Bindings

  @HostBinding('attr.uiinput')
  uiInput = '';

  //#endregion

  //#region Inputs/Outputs

  inputCssClass = input<string | undefined>();

  //#endregion

  //#region Properties

  protected _active = false;

  //#endregion

  //#region Functions

  setActive(active: boolean) {
    this._active = active;
  }

  //#endregion
}
